import { ProductBuyBar } from '@/js/App/ProductBuyBar'
import { Control } from '@peckadesign/pd-naja/dist/types'

class ProductBuyBarControl implements Control {
	initialize(context: Element | Document): void {
		const element = context.querySelector<HTMLElement>(ProductBuyBar.selector)

		if (element) {
			new ProductBuyBar(element)
		}
	}
}

export default new ProductBuyBarControl()
